<script>
  import BenableLogo from '@components/BenableLogo.svelte';
  import CurrentUser from '@components/CurrentUser.svelte';
  import DesktopNavigation from '@app-components/desktop/Navigation.svelte';
  import MobileHeader from '@app-components/mobile/Header.svelte';
  import BottomBar from '@app-components/mobile/BottomBar.svelte';
  import GlobalSearch from '@app-components/global-search/GlobalSearch.svelte';
  import { browser } from '$app/environment';

  export let mobile = false;
  export let currentPage;
  export let currentUser;
  export let currentTab;
  export let quizExpanded = false;
  export let searchTerm;
  export let showCurrentUser = true;

  $: mobileOptions = [];

  $: if (currentPage == 'my-profile' || currentPage == 'dashboard') {
    mobileOptions = [
      'rec-request-group',
      'verification',
      'dashboard',
      'import',
      'bookmarks',
      'settings-submenu',
      'switch-accounts',
      'signout',
    ];
  }

  $: if ((!currentUser || currentUser.isNew) && mobileOptions.length == 0) {
    mobileOptions = ['login', 'get-started'];
  }

  $: showSearch = currentUser && (currentUser.can_search_user || currentUser.can_global_search);
  $: mobileIcon = currentPage == 'my-profile' || currentPage == 'dashboard' ? 'hamburger' : 'dots';
</script>

<style style="text/scss" lang="scss">
  .grid-header-wrapper {
    padding: 20px 90px 45px;
    background: white;

    &.quiz-expanded {
      margin-left: 300px !important;
    }
  }
  .grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 80px;
    max-width: 1360px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;

    .grid-left {
      display: flex;
      align-items: center;
      gap: 80px;
    }
    .grid-right {
      display: flex;
      gap: 30px;
      flex: 1;
      justify-content: flex-end;
    }
  }

  @media only screen and (max-width: 754px) {
    .grid-header {
      padding-top: 10px;
    }
    .grid-nav {
        visibility: hidden;
      }
  }
</style>

{#if mobile}
  {#key mobileOptions}
    {#if mobileOptions.length > 0 || currentPage == 'dashboard' || currentPage == 'feed' || currentPage == 'discover' || currentPage == 'app-invites' || currentPage == 'profile' || currentPage == 'profileSearch'}
      <MobileHeader
        currentUser={currentUser}
        currentPage={currentPage}
        options={mobileOptions}
        icon={mobileIcon}
        currentTab={currentTab} />
    {/if}
  {/key}
  {#if browser}
    <BottomBar currentPage={currentPage} fetchInvites={false} />
  {/if}
{:else}
  <div class="grid-header-wrapper" class:quiz-expanded={quizExpanded}>
    <div class="grid-header">
      <div class="grid-left">
        <div class="grid-logo">
          <BenableLogo href={'/'} />
        </div>
        <div class="grid-nav">
          <DesktopNavigation selected={currentPage} fetchInvites={false} />
        </div>
      </div>
      <slot name="customRightContent" />
      <div class="grid-right">
        {#if showSearch}
          <GlobalSearch
            mobile={false}
            searchTerm={searchTerm}
            keywordSearch={currentUser && currentUser.can_global_search ? true : false} />
        {/if}
        {#if showCurrentUser}
          <CurrentUser currentPage={currentPage} />
        {/if}
      </div>
    </div>
  </div>
{/if}
